"use client"
import Image from "next/image";
import ImageWithLoader from "../shared/imageWithLoader/ImageWithLoader";
import { useContext, useEffect, useRef, useState } from "react";
import ExpandedCard from "./ExpandedCard";
import { TPartner } from "@/app/types/partnerPageTypes";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";

const PartnerCard = ({
	data,
	lastCard,
	optimizedImage,
}: {
	data: TPartner;
	lastCard?: boolean;
	optimizedImage?: boolean;
}) => {
    const [isMore, setIsMore] = useState(false)
    const ref = useRef<HTMLDivElement>(null)
    const { isMobile } = useContext(screenSizeContext)
    const [stringLength, setStringLength] = useState(200)

    useEffect(() => {
        if (isMobile) {
            setStringLength(150)
        }
    }, [isMobile])
    const cardAction = () => {
        if (data?.description?.length > stringLength) {
            setIsMore(!isMore)
            ref?.current?.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <>
            <div className={`
            relative
            border-solid 
            lg:border-e-[1px] 
            lg:border-b-[0px] 
            border-b-[1px] 
            border-oBlack-10 
            last:border-b-0
            last:border-e-0
            lg:pe-[4rem]
            lg:ps-[2.5rem]
            py-[2rem]
            lg:py-[3.25rem]
            ${isMore && "more"}
            ${lastCard && "pb-0"}
        
        `} ref={ref}>
                <div className="relative img_container h-[3rem] w-[3rem] lg:h-[4.5rem] lg:w-[4.5rem]  mb-8 lg:mb-10">
                    {optimizedImage ? (
                        <ImageWithLoader
                            src={data.imgSrc}
                            alt="partner"
                            sizeVariant="thumbnail"
                            contain
                            quality={75}
                        />
                    ) : (
                        <Image src={data.imgSrc} alt="partner" fill className="object-contain" />
                    )}
                </div>
                <h2 className="text-bodyL mb-4">{data?.title}</h2>
                <p className={`text-bodyM font-national text-oBlack-60 
                lg:min-h-[7rem]
            ${"webkit-box webkit-box-orient-vertical line-clamp-4 self-stretch"}
            `}>{data?.description}</p>
                {data?.description?.length > stringLength &&
                    <p
                        onClick={cardAction}
                        className="uppercase text-labelS cursor-pointer underline font-minerva-bold mt-[1rem]">
                        {isMore ? "Read Less" : "Read More"}
                    </p>
                }
                <ExpandedCard
                    isMore={isMore}
                    cardAction={cardAction}
                    data={data}
                    optimizedImage={optimizedImage}
                />
            </div>
        </>
    );
}

export default PartnerCard;